import {
    mdiAccountGroup,
    mdiCalculator,
    mdiCashMultiple,
    mdiDotsHorizontalCircleOutline,
    mdiFileSign,
    mdiHammerWrench,
    mdiInformationOutline,
    mdiPiggyBank,
    mdiScaleBalance,
    mdiVideo,
    mdiVote,
} from '@mdi/js'

/** The glyph of a resolution subject (resolution_subject). */
export const SUBJECT_ICONS: Record<string, string> = {
    bureau_election: mdiAccountGroup,
    works: mdiHammerWrench,
    accounts_approval: mdiCalculator,
    budget: mdiCashMultiple,
    works_fund: mdiPiggyBank,
    syndic_mandate: mdiFileSign,
    council_election: mdiVote,
    council_thresholds: mdiScaleBalance,
    remote_participation_means: mdiVideo,
    information: mdiInformationOutline,
    other: mdiDotsHorizontalCircleOutline,
}

export function subjectIcon(subject: string | undefined): string {
    return SUBJECT_ICONS[subject ?? ''] ?? mdiDotsHorizontalCircleOutline
}
